import {Booking, BookingConfiguration, BookingState, CountBooking} from '../interfaces';

export const mutations = {
  SET_CURRENT_BOOKING(state: BookingState, booking: Booking): void {
    state.currentBooking = booking;
  },
  SET_BOOKING_LIST(state: BookingState, booking: Booking[]): void {
    state.bookingList = booking
  },
  SET_CONFIG(state: BookingState, bookingConfig: BookingConfiguration): void {
    state.bookingConfig = bookingConfig;
  },
  SET_COUNT_BOOKINGS(state: BookingState, countBookings: CountBooking[]): void {
    state.countBookings = countBookings;
  },
  SET_NOT_BOOKABLE_DATES(state: BookingState, notBookableDates: string[]): void {
    state.notBookableDates = notBookableDates;
  },
  SET_ERROR(state: BookingState, error: boolean): void {
    state.error = error;
  },
  SET_ERROR_MESSAGE(state: BookingState, errorMessage: string): void {
    state.errorMessage = errorMessage;
  },
  SET_LOADING(state: BookingState, loading: boolean): void {
    state.loading = loading;
  },
  SET_RESPONSE(state: BookingState, response: boolean): void {
    state.response = response;
  },
  SET_STEP(state: BookingState, step: number): void {
    state.step = step;
  },
  SET_DATE_RANGE(state: BookingState, dates: string[]): void {
    [state.minDate, state.maxDate ] = dates
  },
  SET_NO_BOOKING_POP_UP(state: BookingState, noBooking: boolean): void {
    state.noBookingPopUp = noBooking
  },


};
